import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Redirect to another route without dropping the query string.
 *
 * Notifications store the URL they were created with, so old ones still
 * point at pages that have since moved — and they carry the parameters
 * that make them useful (`?shopping_item_id=…&room=…`), which a plain
 * <Navigate to="..."> would throw away, landing the user on the right
 * page but the wrong room.
 *
 * `to` may contain :project_id, which is filled from the current match.
 */
const RedirectKeepingQuery = ({ to }) => {
  const { project_id } = useParams();
  const { search, hash } = useLocation();

  return (
    <Navigate
      to={{ pathname: to.replace(":project_id", project_id), search, hash }}
      replace
    />
  );
};

export default RedirectKeepingQuery;
